import React from 'react';
import { createRoot } from 'react-dom/client';
// Imported before App so the global Spot stylesheet precedes component styles
import './index.scss';
import App from './App';

// initialises i18next before the app renders
import './i18n';

createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
